import React, { useState } from 'react';
import EditFieldModal from '../Edit Field Modal/EditFieldModal';
import { FaSearch } from 'react-icons/fa';

export default function OSPBasicDetails() {
    const countries = [
        { name: "India", code: "+91" },
        { name: "United States", code: "+1" },
        { name: "United Kingdom", code: "+44" },
        { name: "Australia", code: "+61" },
        { name: "Canada", code: "+1" },
        // add more countries as needed
    ];

    const [sellerBasicDetailsFields, setSellerBasicDetailsFields] = useState({
        companyId: {
            label: "Company ID",
            placeholder: "LBINXXXXX",
            type: "required",
            value: "",
        },
        companyName: {
            label: "Company Name",
            placeholder: "Enter Company name or Web URL",
            type: "required",
            value: "",
        },
        website: {
            label: "Company Website URL",
            placeholder: "Enter Website URL",
            type: "optional",
            value: "",
        },
        natureOfBusiness: {
            label: "Nature of Business",
            placeholder: "Select Nature of Business",
            type: "required",
            options: ['Select', 'Manufacture', 'Farmer', 'Producer', 'Original Service Provider', 'B2B Product Buyer', 'Product Trader', 'Institution bulk buyer for self consumption',
                'B2B Original Service Seller', 'B2B Original Service Buyer', 'Service Reseller'],
            value: 'Select',
        },
        primaryEmail: {
            label: "Primary Email ID",
            placeholder: "Enter Primary Email ID",
            type: "required",
            value: "",
        },
        additionalEmail: {
            label: "Additional Email ID",
            placeholder: "Enter Additional Email ID",
            type: "optional",
            value: "",
        },
        primaryContact: {
            label: "Primary Contact Number",
            placeholder: "Enter Primary Contact No.",
            type: "required",
            value: "",  // will store phone number WITHOUT country code here
        },
        additionalContact: {
            label: "Additional Contact Number (Seperated by(;))",
            placeholder: "Enter Additional Contact No.",
            type: "optional",
            value: "",
        },
        linkedinUrl: {
            label: "Company LinkedIn URL",
            placeholder: "Enter Company LinkedIn URL",
            type: "optional",
            value: "",
        }
    });

    const [selectedCountryCode, setSelectedCountryCode] = useState(countries[0].code); // Default to first country code

    const [editingFieldKey, setEditKey] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [addFieldModalOpen, setAddFieldModalOpen] = useState(false);
    const [basicDetailModalOpen, setBasicDetailModalOpen] = useState(false);
    const [selectedFieldType, setSelectedFieldType] = useState(null);
    const [newField, setNewField] = useState({
        label: '',
        placeholder: '',
        options: ''
    });

    const handleEditClick = (key) => {
        setEditKey(key);
        setIsModalOpen(true);
    };

    const handleSaveField = (updatedField) => {
        setSellerBasicDetailsFields(prev => ({
            ...prev,
            [editingFieldKey]: {
                ...prev[editingFieldKey],
                ...updatedField,
            },
        }));
        setIsModalOpen(false);
    };

    const handleAddField = () => {
        if (!newField.label || !newField.placeholder || !selectedFieldType) {
            alert("Please fill all required fields");
            return;
        }

        const key = newField.label.toLowerCase().replace(/\s+/g, '_') + "_" + Date.now();

        const newFieldData = {
            label: newField.label,
            placeholder: newField.placeholder,
            type: "optional",
            value: "",
        };

        if (["Drop Down", "Radio", "Check Box"].includes(selectedFieldType)) {
            newFieldData.options = newField.options.split(',').map(opt => opt.trim());
            newFieldData.value = newFieldData.options[0] || "";
        }

        setSellerBasicDetailsFields(prev => ({
            ...prev,
            [key]: newFieldData
        }));

        // Reset all
        setNewField({ label: '', placeholder: '', options: '' });
        setSelectedFieldType(null);
        setAddFieldModalOpen(false);
        setBasicDetailModalOpen(false);
    };

    // Handle input changes for other fields
    const handleFieldChange = (key, value) => {
        setSellerBasicDetailsFields(prev => ({
            ...prev,
            [key]: {
                ...prev[key],
                value: value
            }
        }));
    };

    return (
        <div className="p-6 bg-white border-2 border-gray-300 my-5  rounded-lg shadow-md w-full max-w-6xl">
            <h2 className="text-xl font-semibold text-gray-800 underline mb-6">Basic Details :</h2>
            <div className="grid grid-cols-2 gap-8">
                {Object.entries(sellerBasicDetailsFields).map(([key, field]) => (
                    <div key={key} className="flex flex-col">
                        <div className="flex items-center justify-between">
                            <label className="text-md font-semibold text-gray-500">
                                {field.label}
                                {field.type === "required" && <span className="text-red-500">*</span>}
                            </label>
                            {/* <div className="flex gap-4 text-gray-400 text-lg cursor-pointer">
                                <span onClick={() => handleEditClick(key)}>✎</span>
                                <span>✖</span>
                            </div> */}
                        </div>

                        {/* Primary Contact Number with Country Code Select */}
                        {key === "primaryContact" ? (
                            <div className="flex gap-2 mt-1">
                                <select
                                    value={selectedCountryCode}
                                    onChange={(e) => setSelectedCountryCode(e.target.value)}
                                    className="border border-gray-300 rounded-md px-2 py-2 bg-white outline-none"
                                >
                                    {countries.map(({ name, code }) => (
                                        <option key={code} value={code}>
                                            {name} ({code})
                                        </option>
                                    ))}
                                </select>
                                <input
                                    type="tel"
                                    placeholder={field.placeholder}
                                    value={field.value}
                                    onChange={(e) => handleFieldChange(key, e.target.value)}
                                    className="flex-1 border border-gray-300 rounded-md px-3 py-2 outline-none"
                                />
                            </div>
                        ) : field.options ? (
                            <select
                                className="mt-1 w-full border border-gray-300 rounded-md px-3 py-2 outline-none"
                                value={field.value || field.options[0]}
                                onChange={(e) => handleFieldChange(key, e.target.value)}
                            >
                                {field.options.map((opt, index) => (
                                    <option key={index} value={opt}>{opt}</option>
                                ))}
                            </select>
                        ) : (
                            <input
                                type="text"
                                placeholder={field.placeholder}
                                className="mt-1 w-full border border-gray-300 rounded-md px-3 py-2 outline-none"
                                value={field.value || ""}
                                onChange={(e) => handleFieldChange(key, e.target.value)}
                            />
                        )}
                    </div>
                ))}
            </div>

            <div className='grid grid-cols-2 items-center px-10 mt-6'>
                <div className='flex items-center justify-end'>
                    <button
                        onClick={() => setAddFieldModalOpen(true)}
                        className="px-3 py-1 bg-gray-200 font-medium text-gray-600 rounded-md"
                    >
                        Add Field
                    </button>
                </div>
                <div className='flex items-center justify-end'>
                    <button
                        onClick={() => setAddFieldModalOpen(true)}
                        className="px-3 py-1 bg-gray-200 font-medium text-gray-600 rounded-md"
                    >
                        Add Field
                    </button>
                </div>
            </div>

            {/* Step 1: Select Type */}
            {addFieldModalOpen && (
                <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50" >
                    <div className="bg-white w-full max-w-2xl h-fit rounded-lg shadow-lg p-6">
                        <div className='flex items-center justify-between mb-5'>
                            <h1 className="text-xl text-gray-900 font-semibold">Add Fields</h1>
                            <h1 onClick={() => setAddFieldModalOpen(false)} className='text-xl text-gray-900 hover:text-red-600 cursor-pointer font-semibold'>X</h1>
                        </div>

                        <div className="relative">
                            <input
                                type="text"
                                placeholder="Search ..."
                                className="w-full border p-2 mb-4 border-gray-300 rounded-md bg-gray-200 text-gray-500 outline-none"
                            />
                            <FaSearch className="absolute right-3 top-3 text-gray-500" />
                        </div>

                        <h1 className='decoration-2 underline text-gray-900 underline-offset-4 text-lg my-5'>Field Types:</h1>

                        <div className="grid grid-cols-2 gap-5 px-10 mb-5">
                            {["Text fields", "Radio", "Date", "Drop Down", "Slider", "Check Box", "Attachment"].map((type) => (
                                <label key={type} className="flex text-lg items-center gap-2">
                                    <input
                                        type="radio"
                                        value={type}
                                        onChange={() => setSelectedFieldType(type)}
                                        checked={selectedFieldType === type}
                                    />
                                    {type}
                                </label>
                            ))}
                        </div>
                        <div className="flex justify-end gap-2 border-t border-gray-300 pt-5">
                            <button
                                onClick={() => setAddFieldModalOpen(false)}
                                className="px-4 py-1 bg-gray-300 rounded"
                            >
                                Cancel
                            </button>
                            <button
                                onClick={() => {
                                    if (selectedFieldType) {
                                        setAddFieldModalOpen(false);
                                        setBasicDetailModalOpen(true);
                                    } else {
                                        alert("Please select a field type");
                                    }
                                }}
                                className="px-4 py-1 bg-blue-600 text-white rounded"
                            >
                                Next
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Step 2: Enter Details */}
            {basicDetailModalOpen && (
                <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50" >
                    <div className="bg-white w-full h-[70vh] max-w-2xl rounded-lg shadow-lg p-5">
                        <div className='flex items-center justify-between my-5'>
                            <h1 className="text-xl text-gray-900 font-bold">Basic Details</h1>
                            <h1 onClick={() => setBasicDetailModalOpen(false)} className='text-xl text-gray-900 hover:text-red-600 cursor-pointer font-bold'>X</h1>
                        </div>

                        <div className="mb-3 flex items-center justify-between gap-5">
                            <div className='flex-1'>
                                <label className="block text-gray-600 mb-3">Label<span className="text-red-500">*</span></label>
                                <input type="text" placeholder="Enter label name" className="w-full p-2 rounded border border-gray-300" />
                            </div>
                            <div className='flex-2'>
                                <label className="block text-gray-600 mb-3">Type<span className="text-red-500">*</span></label>
                                <select className="w-full p-2 rounded border border-gray-300">
                                    <option>Select</option>
                                    <option>Required</option>
                                    <option>Non-Required</option>
                                </select>
                            </div>
                        </div>

                        {/* <div className="mb-3">
                            <label className="block">Type<span className="text-red-500">*</span></label>
                            <select className="w-full border p-2 rounded" disabled>
                                <option>{selectedFieldType}</option>
                            </select>
                        </div> */}

                        <div className="mb-3">
                            <label className="block text-gray-600 mb-3">Placeholder<span className="text-red-500">*</span></label>
                            <input
                                type="text"
                                value={newField.placeholder}
                                onChange={(e) => setNewField({ ...newField, placeholder: e.target.value })}
                                placeholder="Enter placeholder"
                                className="w-full border border-gray-300 p-2 rounded"
                            />
                        </div>

                        {["Drop Down", "Radio", "Check Box"].includes(selectedFieldType) && (
                            <div className="mb-3">
                                <label className="block text-gray-600 mb-3">Options<span className="text-red-500">*</span></label>
                                <textarea
                                    value={newField.options}
                                    onChange={(e) => setNewField({ ...newField, options: e.target.value })}
                                    placeholder="Enter options separated by commas"
                                    className="w-full h-36 border border-gray-300 p-2 rounded"
                                />
                            </div>
                        )}

                        <div className="flex justify-end gap-2">
                            <button
                                onClick={() => {
                                    setBasicDetailModalOpen(false);
                                    setNewField({ label: '', placeholder: '', options: '' });
                                }}
                                className="px-4 py-1 bg-gray-300 rounded"
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleAddField}
                                className="px-4 py-1 bg-blue-600 text-white rounded"
                            >
                                Add Field
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Edit Modal */}
                <EditFieldModal
                isOpen={isModalOpen}
                    fieldKey={editingFieldKey}
                    fieldData={sellerBasicDetailsFields[editingFieldKey]}
                    onClose={() => setIsModalOpen(false)}
                    onSave={handleSaveField}
                    content={"OSP Basic Details"}
                />
        </div>
    );
}